export { default as MultiColorSelector } from './MultiColorSelector';



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiColorSelector/index.ts